/* Verified RFQ success only. No page-view or click-based lead events. */
(function () {
  'use strict';
  if (window.StellTailsRfq) return;

  var pendingKey = 'st-rfq-pending-v1';
  var emitted = new Set();
  var timeoutMs = 1200;

  function attemptId() {
    return window.crypto.randomUUID();
  }

  function waitForGtm() {
    return new Promise(function (resolve) {
      var startedAt = Date.now();
      function check() {
        if (window.google_tag_manager && window.google_tag_manager['GTM-N392KL3D']) {
          resolve(true);
        } else if (Date.now() - startedAt >= 10000) {
          resolve(false);
        } else {
          window.setTimeout(check, 50);
        }
      }
      check();
    });
  }

  function emitSuccess(formType, formId, id) {
    if (emitted.has(id)) return Promise.resolve();
    emitted.add(id);
    return new Promise(function (resolve) {
      var timer = window.setTimeout(resolve, timeoutMs);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'rfq_success',
        form_type: formType,
        form_id: formId,
        submission_id: id,
        eventCallback: function () {
          window.clearTimeout(timer);
          resolve();
        },
        eventTimeout: timeoutMs
      });
    });
  }

  // Record an attempt, not a conversion. Only Liquid-confirmed success consumes it.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form.st-commercial-rfq-form')) return;
    if (!form.checkValidity()) return;
    try {
      window.sessionStorage.setItem(pendingKey, JSON.stringify({
        id: attemptId(), formId: form.id, createdAt: Date.now()
      }));
    } catch (error) {
      // No reliable cross-navigation deduplication: fail closed, keep form working.
    }
  }, true);

  window.StellTailsRfq = {
    nativeSuccess: function (formId, target) {
      var pending;
      try {
        pending = JSON.parse(window.sessionStorage.getItem(pendingKey));
        window.sessionStorage.removeItem(pendingKey);
      } catch (error) { /* No pending attempt means no lead. */ }
      var complete = Promise.resolve();
      if (pending && pending.formId === formId && typeof pending.id === 'string' &&
          Date.now() - pending.createdAt >= 0 && Date.now() - pending.createdAt < 1800000) {
        // The native success response is a new page; its async GTM may still load.
        // Do not start the redirect timeout before the container can process it.
        complete = waitForGtm().then(function (ready) {
          if (ready) return emitSuccess('native_contact', formId, pending.id);
        });
      }
      // Refreshing the success response cannot reuse the consumed attempt.
      complete.then(function () { window.location.replace(target); });
    }
  };

  // Forms 1058786 has no public success DOM event in the inspected live bundle.
  // Observe only its actual submission response; preserve the response for the app.
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var isRfq = false;
    try {
      var url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
      if (url.origin === 'https://forms.shopifyapps.com' &&
          url.pathname === '/api/v2/form_submission' &&
          init && String(init.method).toUpperCase() === 'POST' && typeof init.body === 'string') {
        var body = JSON.parse(init.body);
        isRfq = String(body.form_instance_id) === '1058786' &&
          body.shopify_domain === window.Shopify.shop;
      }
    } catch (error) { /* Unrelated requests pass through unchanged. */ }
    var result = originalFetch.apply(this, arguments);
    if (!isRfq) return result;
    return result.then(async function (response) {
      try {
        // Observed on the real form on 2026-09-20. Unknown responses fail closed.
        if (response.status === 202 && /application\/json/i.test(response.headers.get('content-type') || '')) {
          var data = await response.clone().json();
          if (data.message === 'Company created successfully.' && data.errors &&
              typeof data.errors === 'object' && Object.keys(data.errors).length === 0) {
            await emitSuccess('shopify_forms', '1058786', attemptId());
          }
        }
      } catch (error) { /* Tracking must never block a successful RFQ. */ }
      return response;
    });
  };
})();
